const KeyCodes = {
    ACCELERATE: [38, 87],
    BRAKE: [40, 83],
    LEAN_LEFT: [37, 65],
    LEAN_RIGHT: [39, 68],
    START: 68
}

export default KeyCodes;